import React, { useState } from "react";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

/**
 * A label with an optional info icon that shows a tooltip on hover.
 * 
 * Props:
 *  - label (string|node): The label text to display
 *  - tooltip (string): Tooltip text shown on hover over the info icon. If omitted, no icon is shown.
 *  - iconSize (number): Font size of the info icon (default: 16)
 *  - iconColor (string): Color of the info icon on hover (default: "#0D4A81")
 */
export default function LabelWithTooltip({ label, tooltip, iconSize = 16, iconColor = "#0D4A81" }) {
    const [hovered, setHovered] = useState(false);
    return (
        <span style={{ display: "flex", alignItems: "center" }}>
            {label}
            {tooltip &&
                <span data-for="globalTT" data-tip={tooltip}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}>
                    <InfoOutlinedIcon style={{ fontSize: iconSize, marginLeft: 4, color: hovered ? iconColor : "#CCCCCC", cursor: "pointer", transition: "color 0.2s" }} />
                </span>
            }
        </span>
    );
}
